import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import axios from 'axios';
import SERVER from './useServer';

export const useApi = () => {
  const { i18n } = useTranslation();
  
  const getLang = useCallback(() => {
    // Get language from i18n or localStorage
    const lang = i18n.language || localStorage.getItem('i18nextLng') || 'fr';
    console.log('[useApi] Current language:', lang, '| i18n.language:', i18n.language);
    return lang;
  }, [i18n.language]);
  
  const fetchProducts = useCallback(async (params = {}) => {
    const lang = getLang();
    console.log('[useApi] Fetching products with lang:', lang);
    const response = await axios.get(`${SERVER}/products`, {
      params: { ...params, lang }
    });
    return response.data;
  }, [getLang]);
  
  const fetchProduct = useCallback(async (productId) => {
    const response = await axios.get(`${SERVER}/products/${productId}`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);
  
  const fetchCategories = useCallback(async () => {
    const response = await axios.get(`${SERVER}/categories`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);
  
  const fetchSubCategories = useCallback(async () => {
    const response = await axios.get(`${SERVER}/subcategories`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);
  
  const fetchFeaturedProducts = useCallback(async () => {
    const response = await axios.get(`${SERVER}/products/featured`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);
  
  const fetchTopPromotions = useCallback(async () => {
    const response = await axios.get(`${SERVER}/products/top-promotions`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);

  const fetchAllPromotions = useCallback(async () => {
    const response = await axios.get(`${SERVER}/products/all-promotions`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);

  const fetchNewProducts = useCallback(async () => {
    const response = await axios.get(`${SERVER}/products/nouveautes`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);

  const fetchSubCategoriesByCategory = useCallback(async (categoryId) => {
    const response = await axios.get(`${SERVER}/subcategories/by-category/${categoryId}`, {
      params: { lang: getLang() }
    });
    return response.data;
  }, [getLang]);
  
  return {
    fetchProducts,
    fetchProduct,
    fetchCategories,
    fetchSubCategories,
    fetchSubCategoriesByCategory,
    fetchFeaturedProducts,
    fetchTopPromotions,
    fetchAllPromotions,
    fetchNewProducts,
    currentLanguage: getLang()
  };
};

export default useApi;
